export default __webpack_public_path__ + "static/tech-godaddy-235e0cdd614e1205e3f461c9ac7414f9.png";